import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import DOMPurify from "dompurify";
import "./News.scss";
import PageBanner from "../layouts/PageBanner";
import aboutHero from "../../assets/about-hero.jpg";

const API = "https://api.ainfotech.com.np";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined); // undefined while loading, null when 404
  const [others, setOthers] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setErr("");
        setPost(undefined); // loading state
        const r1 = await fetch(`${API}/api/eventmedia/${slug}`);
        if (r1.status === 404) {
          setPost(null); // mark as not found
          return;
        }
        const d1 = await r1.json();
        if (!r1.ok) throw new Error(d1?.error || "Failed to load");
        setPost(d1);

        const r2 = await fetch(`${API}/api/eventmedia?status=published&page=1&limit=5`);
        const d2 = await r2.json();
        setOthers((d2.items || []).filter((x) => x.slug !== d1.slug));
        window.scrollTo(0, 0);
      } catch (e) {
        setErr(e.message);
      }
    })();
  }, [slug]);

  // ✅ Hooks BEFORE any conditional returns
  const safeHtml = useMemo(
    () => ({ __html: DOMPurify.sanitize(post?.content_html || "") }),
    [post]
  );

  const hero = post?.cover_image ? `${API}${post.cover_image}` : "";
  const date = post?.published_at ? new Date(post.published_at).toLocaleDateString() : "";

  // Now it’s safe to branch
  if (post === null) return <Navigate to="/news" replace />;
  if (post === undefined) return <div className="container py-5">Loading…</div>;

  return (
    <div className="avena-news">
      <PageBanner
        title="News & Events"
        bg={aboutHero}
        crumbs={[
          { label: "Home", href: "/" },
          { label: "News & Events", href: "/news" },
          
        ]}
      />

      <section className="container py-5">
        {err && <div className="alert alert-danger">{err}</div>}

        <div className="row g-5">
          <div className="col-12 col-lg-8">
            <article className="avena-post">
              <h1 className="avena-post__title">{post.title}</h1>
              <div className="avena-post__byline">
                {date && <span className="dot-sep">{date}</span>}
              </div>
              {hero && (
                <div className="avena-post__hero">
                  <img src={hero} alt={post.title} />
                </div>
              )}
              <div className="pd-rich" dangerouslySetInnerHTML={safeHtml} />
            </article>
          </div>

          <aside className="col-12 col-lg-4">
            <div className="avena-sidebar card p-3 p-md-4">
              <h5 className="avena-sidebar__title">Other News</h5>
              <ul className="list-unstyled avena-sidebar__list">
                {others.map((o) => (
                  <li key={o.id} className="avena-sidebar__item">
                    <Link to={`/news/${o.slug}`} className="avena-sidebar__link">
                      <div className="avena-sidebar__thumb">
                        {o.cover_image && <img src={`${API}${o.cover_image}`} alt={o.title} />}
                      </div>
                      <div className="avena-sidebar__meta">
                        {o.published_at && (
                          <div className="avena-sidebar__date">
                            {new Date(o.published_at).toLocaleDateString()}
                          </div>
                        )}
                        <div className="avena-sidebar__title">{o.title}</div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link to="/news" className="btn btn-outline-secondary w-100 mt-2">
                All posts
              </Link>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
